import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CHART_STRINGS } from '../helpers/graphConstants';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) {
    return null;
  }

  const withoutTreatment = payload.find(
    (p) => p.dataKey === 'withoutTreatment'
  );
  const withTreatment = payload.find((p) => p.dataKey === 'withTreatment');

  if (!withoutTreatment && !withTreatment) {
    return null;
  }

  return (
    <div className="custom-tooltip">
      <div>
        <strong>{label}</strong> {CHART_STRINGS.YRS_UNIT}
      </div>
      {withoutTreatment && withoutTreatment.value !== null && (
        <div>
          {CHART_STRINGS.NO_TREATMENT_EGFR}: {withoutTreatment.value.toFixed(1)}
        </div>
      )}
      {withTreatment && withTreatment.value !== null && (
        <div>
          {CHART_STRINGS.TREATMENT_EGFR}: {withTreatment.value.toFixed(1)}
        </div>
      )}
    </div>
  );
};

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.arrayOf(PropTypes.object),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default memo(CustomTooltip);
